import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Doughnut } from 'react-chartjs-2';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';


const MyModuleSegment = ({totals, title = 'My Modules', onElementsClick, completed = false}) => {

    const infoLink = completed ? "/dashboard/mytraining/modules?completed=true" : "/dashboard/mytraining/modules";

    const data = {
        labels: [
            'Classroom',
            'e-Learning',
            'Resource',
            'Video'
        ],
        datasets: [{
            data: totals,
            backgroundColor: [
                statusColours['primary_2'],
                statusColours['primary'],
                statusColours['primary_3'],
                statusColours['primary_4'],
            ],
            hoverBackgroundColor: [
                statusColours['primary_2_o'],
                statusColours['primary_o'],
                statusColours['primary_3_o'],
                statusColours['primary_4_o'],
            ]
        }]
    };

    return (
        <Card className="cent-card ">
            <CardHeader
                title={<Link to={infoLink} >{title}</Link>}
                subtitle={!!totals && `${totals.reduce((acc, curr) => acc + curr , 0)} Modules`}
                avatar={<Link to={infoLink}><ModuleIcon color={statusColours.default} /></Link>}
            />
            <CardText className="cent-card-chips">
                <Doughnut data={data} onElementsClick={onElementsClick} options={{legend: {position: 'bottom'}}}/>
            </CardText>
        </Card>
    );
};

MyModuleSegment.propTypes = {
    title: PropTypes.string,
    totals: PropTypes.array,
    onElementsClick: PropTypes.func,
    completed: PropTypes.bool
};

export default MyModuleSegment;
